import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAClient,
  getClients,
  resetState,
} from "../features/clients/clientSlice";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Title",
    dataIndex: "title",
  },
    {
      title: "Image",
      dataIndex: "image",
      render: (url) =>
        url ? <img src={url} alt="Client" style={{ width: 50 }} /> : "No Image",
      width: 80,
    },
  {
    title: "Action",
    dataIndex: "action",
     align: "center",
  },
];

const ClientList = () => {
  const [open, setOpen] = useState(false);
  const [clientId, setClientId] = useState("");
  const dispatch = useDispatch();

  const showModal = (id) => {
    setOpen(true);
    setClientId(id);
  };

  const hideModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(resetState());
    dispatch(getClients());
  }, [dispatch]);

  const clientState = useSelector((state) => state.clients.clients);

  const dataSource = clientState.map((client, index) => ({
    key: index + 1,
    title: client.title,
    image: client.images?.[0]?.url || "",
    action: (
      <>
        <Link to={`/admin/client/${client._id}`} className="fs-3 text-primary">
          <BiEdit />
        </Link>
        <button
          className="ms-3 fs-3 text-danger bg-transparent border-0"
          onClick={() => showModal(client.slug)}
        >
          <AiFillDelete />
        </button>
      </>
    ),
  }));

  const deleteClient = (slug) => {
    dispatch(deleteAClient(slug));
    setOpen(false);
    setTimeout(() => {
      dispatch(getClients());
    }, 100);
  };

  return (
    <div>
      <h3 className="mb-4 title">Clients List</h3>
      <Table columns={columns} dataSource={dataSource} />
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => deleteClient(clientId)}
        title="Are you sure you want to delete this client?"
      />
    </div>
  );
};

export default ClientList;
